import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { Provider } from "react-redux";
import App from "./App";
import "./main.css";
import store from "./redux/store";
import { defaultTheme } from "./theme/default.theme";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

dayjs.extend(utc);
dayjs.extend(timezone);

root.render(
    <HelmetProvider>
        <Provider store={store}>
            <ThemeProvider theme={defaultTheme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <App />
                </LocalizationProvider>
            </ThemeProvider>
        </Provider>
    </HelmetProvider>,
);
